<template>
  <div class="selected z-index-1 q-pa-sm bg-grey-9 text-white shadow-1">
    <div v-if="$slots['default']" class="selected-label relative-position">
      <div class="text-caption line-height-1 text-grey-5">Selected</div>
      <slot />
    </div>
    <div v-else>Selected: {{ emitValue ? value : value[optionLabel] }}</div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ emitValue?: boolean; optionLabel?: string; value: unknown }>();
</script>
